import React from "react";
import { Link } from "react-router-dom";


const AboutSix = () => {
  return (
    <div
      className="slider-perosonal-portfolio height-750 bg_image"
      data-black-overlay="1"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/dare/plano-interior-cafe-sillas-cerca-bar-mesas-madera.jpg)`,
      }}
    >
      <div className="container">
        <div className="row row--30 align-items-center">
          <div className="col-12">
            <div className="inner text-center">
              <h1 className="title">
                El método es <br />{" "}
                <span className="theme-gradient">implementar mejoras</span>
              </h1>
              <div className="button-group mt--30">
                <Link className="btn-default round btn-border btn-large" to="/contacto">
                  Contactanos
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutSix;
